function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2e4bb5",
  d: "M.56 7.006a12.805 12.805 0 0 0 .571 1.21l.092.174c.153.287.316.571.482.851l.1.167c.238.387.479.763.709 1.114q.255.383.5.709c.192.27.376.521.546.748s.27.355.383.5l.245.312c.174.22.277.355.277.355S8.722 8 8.946 4.885A4.611 4.611 0 0 0 8.4 2.228q-.085-.149-.181-.287a3.9 3.9 0 0 0-.433-.507c-.05-.053-.1-.1-.156-.153l-.149-.153c-.061-.045-.117-.092-.181-.134a3.643 3.643 0 0 0-.352-.245c-.06-.035-.124-.074-.191-.106l-.1-.05q-.1-.053-.2-.1l-.1-.035L6.14.38 5.93.313A5.005 5.005 0 0 0 4.469.1 4.356 4.356 0 0 0-.022 4.889a5.449 5.449 0 0 0 .206 1.1c.032.11.067.22.106.333a.516.516 0 0 0 .057.167q.057.17.128.355a.617.617 0 0 1 .085.162zm3.9-5.058a2.628 2.628 0 1 0 .007 0z",
  transform: "translate(.034 -.1)"
});

var SvgDoIcon = function SvgDoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "-1 0 11 13.05",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/do-icon.c490165b.svg";
export { ForwardRef as ReactComponent };